// TopNavBar.js
import React, { useState, useEffect, useRef } from "react";
import { Typography } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell,
  faMoneyBills,
  faRightFromBracket,
  faSortDown,
  faUserCircle,
  faBars, // Import faBars
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

import { faShop, faPhone } from "@fortawesome/free-solid-svg-icons";

import { useUserContext, Statescontex } from "../../context";
import { handleLogout } from "../../services/apicall.tsx";
import designicons from "../../devdata/assets";
import { colors } from "../../devdata/constants/themes.js";
import { useNavigate } from "react-router-dom";
const { Text } = Typography;

const TopNavBar = ({ isMobileView, isMobileMenuOpen, setIsMobileMenuOpen }) => {
  // Receive props
  const { userdetails } = useUserContext();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { setloading, setErrorMessage, setErrorshow } = Statescontex();
  const { setlogin, setuserToken, userToken } = useUserContext();
  const navi = useNavigate()

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const closeDropdown = () => setDropdownOpen(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    if (dropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpen]);

  const handleLogoutClick = () => {
    setloading(true);
    sessionStorage.clear();
    handleLogout(
      setloading,
      userToken,
      setuserToken,
      setlogin,
      navi,
      setErrorMessage,
      setErrorshow
    );
    closeDropdown();
  };

  const dropdownItems = [
    {
      label: "Profile Settings",
      icon: designicons._UserAvatarCircleIcon_,
      link: "/profile",
      id: 1,
    },
    {
      label: "My Watchlist",
      icon: designicons._HighlightsIcon_,
      link: "/Myday",
      id: 2,
    },
    {
      label: "Plans and Pricing",
      icon: designicons.Cash,
      link: "/Subscriptions",
      id: 3,
    },
    {
      label: "Support",
      icon: designicons._DialOutIcon_,
      link: "/help",
      id: 4,
    },
  ];

  const toggleMobileMenu = () => {
    // Function to toggle mobile sidebar
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="bg-darkMode-background px-6 py-4 flex justify-between items-center w-full z-40 relative">
      {" "}
      {/* Changed justify-end to justify-between */}
      <div className="flex items-center space-x-4">
        {" "}
        {/* Left side container */}
        {/* Hamburger Icon - Visible on Mobile */}
        {isMobileView && (
          <button
            onClick={toggleMobileMenu} // Toggle mobile menu state
            className="text-darkMode-text cursor-pointer bg-darkMode-layer2 px-3.5 py-3 rounded-full shadow-md lg:hidden" // Hidden on desktop
            aria-label="Open Sidebar"
          >
            <FontAwesomeIcon icon={faBars} size="lg" />
          </button>
        )}
      </div>
      <div className="flex items-center space-x-4">
        {/* Right side container */}
        {/* Cashoo Icon - Hidden on Mobile */}
        <Link to="/Subscriptions">
          <div className="text-darkMode-text cursor-pointer bg-darkMode-layer2 px-3.5 py-3.5 rounded-full shadow-md">
            <designicons.Cash fill={colors.darkMode.text} />
          </div>
        </Link>
        <div className="relative">
          <div
            onClick={toggleDropdown}
            className="bg-darkMode-layer2 rounded-full flex items-center gap-2 py-3.5 px-4 cursor-pointer"
          >
            <div className="flex items-center justify-center">
              <designicons._UserAvatarCircleIcon_ fill={colors.darkMode.text} />
            </div>
            {/* Conditionally render name - Hide on Mobile */}
            {!isMobileView && (
              <span className="text-darkMode-text">{userdetails?.name}</span>
            )}
            <FontAwesomeIcon
              icon={faSortDown}
              className="text-darkMode-text relative -top-1"
            />
          </div>

          {dropdownOpen && (
            <div
              ref={dropdownRef}
              className="absolute right-0 mt-2 bg-darkMode-layer1 rounded-2xl shadow-md w-52 border border-darkMode-layer3"
            >
              <div className="transition-all duration-300">
                {/* Dropdown Header - Always Show Name here */}
                <div className="px-4 pt-4 pb-2">
                  <div className="text-lg font-semibold text-darkMode-text">
                    {userdetails?.name}
                  </div>
                  <div className="text-sm text-darkMode-subText">
                    {userdetails?.email}
                  </div>
                </div>
                <div className="border-b border-darkMode-layer2 h-0.5"></div>

                {dropdownItems.map((item, index) => (
                  <div key={item.id}>
                    <div
                      key={item.id}
                      className="px-4 py-3 cursor-pointer text-darkMode-text hover:bg-darkMode-background group"
                    >
                      <Link
                        onClick={closeDropdown}
                        to={item.link}
                        className="flex flex-row items-center gap-2"
                      >
                        {item.icon && (
                          <div className="w-5 h-5 flex items-center justify-center group-hover:text-darkMode-green">
                            {/*  colors.darkMode.green normal color colors.darkMode.text*/}
                            <item.icon fill={colors.darkMode.text} />
                            {/* <FontAwesomeIcon icon={item.icon} size="lg" /> */}
                          </div>
                        )}
                        <span className="">{item.label}</span>
                      </Link>
                    </div>
                    {/* dont render last separator */}
                    {index !== dropdownItems.length - 1 && (
                      <div className="border-b border-darkMode-layer2 h-0.5"></div>
                    )}
                  </div>
                ))}
              </div>

              <div className="border-b border-darkMode-greenDarker/20"></div>

              {/* Logout Option */}
              <div className="transition-all duration-300 pt-2 rounded-b-2xl hover:bg-darkMode-background ">
                <div
                  onClick={handleLogoutClick}
                  className="px-4 py-3 cursor-pointer text-darkMode-text  group hover:rounded-2xl"
                >
                  <div className="flex flex-row items-center gap-2">
                    <div className="w-5 h-5 flex items-center justify-center ">
                      {/* <FontAwesomeIcon icon={faRightFromBracket} size="lg" /> */}
                      <designicons._SignInIcon_ fill={colors.darkMode.text} />
                    </div>
                    <span className="">Log Out</span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopNavBar;
